var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHabitantes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 42",
    style: {
      enableBackground: "new 0 0 92 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3C4552;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-36.116 -88.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_446713592",
    transform: "translate(35.274 39.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_259927288",
    className: "st0",
    d: "M62.6,88.4C62.6,88.4,62.6,88.4,62.6,88.4C62.6,88.3,62.6,88.3,62.6,88.4v-1.6 c0-7.2-5-13.4-12.1-15.1c-2.5,0.9-5.2,0.9-7.7,0c-7.1,1.7-12.1,7.9-12.1,15.1v3.8h31.9V88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259926664",
    className: "st0",
    d: "M76.9,69.1c-1.3,0-2.6-0.2-3.9-0.7c-4.9,1.2-8.9,4.6-10.9,9.1c1.7,2.8,2.7,6,2.7,9.2v0.5h28 v-3.8c0-7.2-5-13.4-12.1-15.1C79.5,68.9,78.2,69.1,76.9,69.1L76.9,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259927192",
    className: "st0",
    d: "M76.9,50.1c-4.7,0-8.6,3.8-8.6,8.4s3.8,8.4,8.6,8.4c4.7,0,8.6-3.8,8.6-8.4 C85.5,53.8,81.6,50.1,76.9,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259926568",
    className: "st0",
    d: "M17.6,69.1c-1.3,0-2.6-0.2-3.9-0.7C6.7,70.1,1.7,76.3,1.7,83.5v3.8h26.8v-0.5 c0-3.7,1.2-7.3,3.4-10.2c-2.1-4.1-5.9-7-10.4-8.1C20.2,68.9,18.9,69.1,17.6,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_259925824",
    className: "st0",
    d: "M17.6,50.1c-4.7,0-8.6,3.8-8.6,8.4c0,4.7,3.8,8.4,8.6,8.4c4.7,0,8.6-3.8,8.6-8.4 C26.2,53.8,22.3,50.1,17.6,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_446713064",
    className: "st0",
    d: "M46.7,53.4c-4.7,0-8.6,3.8-8.6,8.4c0,4.7,3.8,8.4,8.6,8.4c4.7,0,8.6-3.8,8.6-8.4c0,0,0,0,0,0 C55.2,57.1,51.4,53.4,46.7,53.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHabitantes);
export default __webpack_public_path__ + "static/media/icon-habitantes.8ac99c82156c776ba6c56c76c07a2051.svg";
export { ForwardRef as ReactComponent };